import { lmURLType } from '@/utils/helpers';

// Custom modal handling
// Custom 'modal_open' event
const modalOpenEvent = new Event( 'modal_open' );
export default class LMModal {
    constructor( e: Event ) {
        e.preventDefault();
        const obj: HTMLElement = e.currentTarget as HTMLElement;
        if ( obj.classList.contains( 'lm-modals' ) ) {
            this.modalsInWrapper( obj );
        }
        if ( obj.classList.contains( 'lm-modal' ) ) {
            this.modal( obj );
        }
    }
    modalsInWrapper( modals: HTMLElement ) {
        const aTags: HTMLCollection = modals.getElementsByTagName( 'a' );
        modals.setAttribute( 'uk-lightbox', '' );
        for ( const aTag of aTags ) {
            const href: string | null = aTag.getAttribute( 'href' );
            if ( href && href.indexOf( 'http' ) == -1 && href.indexOf( '/iframe' ) == -1 ) {
                aTag.setAttribute( 'href', '/iframe' + href );
            }
            if ( href && href.indexOf( 'vimeo' ) == -1 ) {
                aTag.setAttribute( 'data-type', 'iframe' );
            }
        }
    }
    modal( modal: HTMLElement ) {
        let href: string | null = modal.getAttribute( 'href' );
        href = href ? href.replace( window.relativeHomeURL, '' ) : '';
        // If relative url or local url or vimeo video
        if ( href.indexOf( 'http' ) == -1 || href.indexOf( 'vimeo' ) > -1 ) { 
            // If page or video
            if ( lmURLType( href ) === 'page' || lmURLType( href ) === 'video' ) {
                // If relative url
                if ( href.indexOf( 'http' ) == -1 ) {
                    // If no iframe parameter
                    if ( href.indexOf( '/iframe' ) == -1 ) {
                        // Add iframe parameter to url
                        modal.setAttribute( 'href', window.relativeHomeURL + '/iframe' + href );
                    }
                }
            }
            // If we're proceeding with the modal, lightbox element hasn't been added yet
            if ( ! modal.classList.contains( 'lm-modal-window' ) ) {
                modal.classList.add( 'lm-modal-window' );
            }
        }
        this.modalWindow( modal );
    }
    modalWindow( modal: HTMLElement ) {
        const urlRaw: string | null = modal.getAttribute( 'href' );
        const url: string = urlRaw ? urlRaw : '';
        const urlType: string | null = modal.getAttribute( 'data-url-type' ) ? modal.getAttribute( 'data-url-type' ) : '';
        const modalClass: string | null = modal.getAttribute( 'data-modal-class' ) ? modal.getAttribute('data-modal-class') : '';
        // Build the modal
        const modalWrapper: HTMLElement = document.createElement( 'div' );
        const modalInnerWrapper: HTMLElement = document.createElement( 'div' );
        const closeButton: HTMLElement = document.createElement( 'button' );
        const closeButtonText: HTMLElement = document.createElement( 'span' );
        modalWrapper.setAttribute( 'class', 'lm-modal-window-wrapper ' + urlType );
        if ( modalClass ) {
            modalWrapper.classList.add( modalClass );
        }
        modalInnerWrapper.setAttribute( 'class', 'lm-modal-window-inner-wrapper' );
        closeButton.setAttribute( 'class', 'lm-modal-window-close' );
        closeButtonText.textContent = 'Close';
        closeButton.appendChild( closeButtonText );
        closeButton.addEventListener( 'click', function ( e ) {
            modalWrapper.remove();
        } );
        modalInnerWrapper.appendChild( closeButton );
        modalWrapper.appendChild( modalInnerWrapper );
        switch ( urlType ) {
            case 'image':
                break;
            case 'video':
                const modalVideo: HTMLElement = document.createElement( 'figure' );
                const modalVideoIframe: HTMLElement = document.createElement( 'iframe' );
                modalInnerWrapper.classList.add( 'lm-video-wrapper' );
                modalVideo.setAttribute( 'class', 'lm-video' );
                modalVideoIframe.setAttribute( 'src', url );
                modalVideoIframe.setAttribute( 'frameborder', '0' );
                modalVideoIframe.setAttribute( 'allow', 'autoPlay; fullscreen; picture-in-picture' );
                modalVideoIframe.setAttribute( 'allowfullscreen', '' );
                modalVideo.appendChild( modalVideoIframe );
                modalInnerWrapper.appendChild( modalVideo );
                break;
            default:
                const modalIframeWrapper: HTMLElement = document.createElement( 'div' );
                const modalIframe: HTMLElement = document.createElement( 'iframe' );
                modalIframeWrapper.setAttribute( 'class', 'lm-iframe-wrapper' );
                modalIframe.setAttribute( 'src', url );
                modalIframe.setAttribute( 'frameborder', '0' );
                modalIframeWrapper.appendChild( modalIframe );
                modalInnerWrapper.appendChild( modalIframeWrapper );
                break;
        }
        document.body.appendChild( modalWrapper );
        closeButton.focus();
        document.dispatchEvent( modalOpenEvent );
    }
}